<wr-new-data-table headerText="Dienstleisterübersicht"
                   localStorageIdentifier="contractor-tenant-overview"
                   [loadItemsFunction]="loadTenants"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToTenant($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
        @if (currentTenant()?.type === 'External') {
          <div class="filter-control-group">
            <label class="label" for="contractorNumber">Lieferantennummer</label>
            <input type="text" nbInput id="contractorNumber"
                   formControlName="contractorNumber" placeholder="Lieferantennummer...">
          </div>
        }
        @if (currentTenant()?.type === 'External') {
          <div class="filter-control-group">
            <label class="label" for="facilityElement">Technische Einrichtung</label>
            <wr-facility-element-select id="facilityElement" formControlName="facilityElement" [showEmptyOption]="true">
            </wr-facility-element-select>
          </div>
        }
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-organisation
    key="name"
    display="Name">
    @if (organisation.name) {
      <div [ngStyle]="{color:organisation.color}">
        {{organisation.name}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-organisation
    key="paymentAddressStreet"
    [exportValue]="exportStreet"
    display="Straße">
    @if (organisation.paymentAddress; as address) {
      <div>
        <span>{{address.street}} {{address.number}}</span>
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-organisation
    key="paymentAddressZipCode"
    [exportValue]="exportZip"
    display="PLZ">
    @if (organisation.paymentAddress; as address) {
      <div>
        {{address.country}}-{{address.zipCode}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-organisation
    key="paymentAddressCity"
    exportKey="paymentAddress.city"
    display="Stadt">
    @if (organisation.paymentAddress; as address) {
      <div>
        {{address.city}}
      </div>
    }
  </ng-template>
</wr-new-data-table>
